import React, { JSX } from 'react'
import { motion } from 'framer-motion';

export default function splitLine(line: string) {

    const letterStyles = {
        hidden: {
            opacity: 0,
        },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.15,
            },
        },
    }

    return line.split("").map((char, index) => {
        const isSpace = char === ' ';
        return (
            <motion.span
                key={index}
                variants={letterStyles}
            >
                {isSpace ? '\u00A0' : char}
            </motion.span>
        );
    });
}